import * as React from "react";
import UserList from "../../presentations/UserList";
import MembersStatsContainer from "../MembersStatsContainer";

const UserListContainer = (props: any) => {

  
  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    onEdit(rowData);
  }

  return (
    <div>
      <div className="mx-4 my-2">
        <MembersStatsContainer></MembersStatsContainer>
      </div>
      <div className="m-4">
        <UserList onEdit={handleOnEdit}></UserList>
      </div>
    </div>
  );
};

export default UserListContainer;
